import { useApiUrl } from '@gemini/lux-ds-pms';
import { OBRoutes } from '@utils/apiRoutes';
import { GeneralConfigDTO } from '@utils/interfaces';
import { Modes } from '@utils/enums/Modes.enum';
import { useMemo } from 'react';
import { mergeObjects } from '@utils/functions';
import { useOBQuery } from '@hooks/useOBQuery';

interface FormConfigProps {
  practiceId: string;
  mode?: Modes;
}

const useGetGeneralConfig = ({
  practiceId,
  mode = Modes.STANDALONE,
}: FormConfigProps) => {
  const url = useApiUrl(
    OBRoutes.GeneralConfig,
    'ONLINEBOOKING_CLIENT_BFF_API_BASE_URL',
  )?.replace('##practiceId', practiceId);

  const query = useOBQuery<GeneralConfigDTO>(url, {
    enabled: !!url && !!practiceId,
  });

  // EMBEDDED mode -> wait for query success and then merge data with window.luxOB.generalConfig
  const mergedData = useMemo(() => {
    if (
      mode === Modes.EMBEDDED &&
      window?.luxOB?.configurations?.generalConfig &&
      query.isSuccess &&
      query.data
    ) {
      return mergeObjects<GeneralConfigDTO>(
        query.data,
        window.luxOB.configurations.generalConfig,
        true,
      );
    } else return query.data;
  }, [mode, query.data, query.isSuccess]);

  return {
    ...query,
    data: mergedData,
  };
};

export default useGetGeneralConfig;
